import { archiverUrl, fetchWithAuthorization } from '../../helpers/utils';

const BlockingSessionApi = {
    fetchTime: (timeRangeQS: string, instanceId: number): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl()}/blocking/session/time?${timeRangeQS}&id=${instanceId}`),
    fetch: (timeRangeQS: string, instanceId: number): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl()}/blocking/session?${timeRangeQS}&id=${instanceId}`),
};

export default BlockingSessionApi;
